export const CALL_TO_ACTION_OPTION = 'call_to_action_option'
export const CALL_TO_ACTION_LEARN_MORE = 'call_to_action_learn_more'
export const CALL_TO_ACTION_SELECT = 'call_to_action_select'
export const CALL_TO_ACTION = 'call_to_action'
export const LEARN_MORE = 'LEARN_MORE'
